export const Logo = () => (
  <svg
    width="18"
    height="29"
    viewBox="0 0 18 29"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12.749 7.987a4.876 4.876 0 0 0-1.434-3.452 4.902 4.902 0 0 0-3.462-1.43 4.889 4.889 0 0 0-4.895 4.882 4.889 4.889 0 0 0 4.895 4.882 4.889 4.889 0 0 0 4.896-4.882zm2.905 0 .004-.002c0 2.06-.82 4.034-2.28 5.49a7.793 7.793 0 0 1-5.503 2.275 7.786 7.786 0 0 1-7.198-4.79 7.75 7.75 0 0 1 1.685-8.464A7.8 7.8 0 0 1 10.848.81a7.765 7.765 0 0 1 4.806 7.176z"
        id="6gwzj9ajaa"
      />
      <path
        d="M6.559 4.832a1.77 1.77 0 0 0-1.773-1.768 1.77 1.77 0 0 0-1.773 1.768 1.77 1.77 0 0 0 1.773 1.769 1.77 1.77 0 0 0 1.773-1.769zm2.92 0a4.65 4.65 0 0 1-1.367 3.292 4.674 4.674 0 0 1-3.3 1.364A4.661 4.661 0 0 1 .143 4.832 4.661 4.661 0 0 1 4.81.177 4.661 4.661 0 0 1 9.48 4.832z"
        id="tm4biekx4c"
      />
      <path
        d="M1.832 3.518A1.7 1.7 0 0 1 .13 1.82 1.7 1.7 0 0 1 1.832.122 1.7 1.7 0 0 1 3.535 1.82a1.7 1.7 0 0 1-1.703 1.698z"
        id="ia2r40aime"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(.5 2.5)">
        <mask id="c4aaaej5wb" fill="#fff">
          <use xlinkHref="#6gwzj9ajaa" />
        </mask>
        <path fill="#2396FD" mask="url(#c4aaaej5wb)" d="M.08 15.76h15.59V.2H.08z" />
      </g>
      <g transform="translate(7.5 18.5)">
        <mask id="q6ep6zc8vd" fill="#fff">
          <use xlinkHref="#tm4biekx4c" />
        </mask>
        <path fill="#2396FD" mask="url(#q6ep6zc8vd)" d="M.119 9.51h9.376V.161H.12z" />
      </g>
      <g transform="translate(12.5 .5)">
        <mask id="rk5unz63jf" fill="#fff">
          <use xlinkHref="#ia2r40aime" />
        </mask>
        <path fill="#2396FD" mask="url(#rk5unz63jf)" d="M.11 3.534h3.448V.114H.109z" />
      </g>
    </g>
  </svg>
);
